import { Locale } from 'modules/i18n';

export const paygLabelTranslation = {
  [Locale.en]: {
    label: 'Pay-as-you-go',
  },
};
